import { render } from "./invite-a-friend-modal.vue?vue&type=template&id=0a1f9554&ts=true"
import script from "./invite-a-friend-modal.vue?vue&type=script&lang=ts"
export * from "./invite-a-friend-modal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__